var _rect, _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotifyTalk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5251 7.58204C25.2204 6.52735 22.7121 6 20 6C17.2879 6 14.7796 6.52735 12.4749 7.58204C10.1702 8.63673 8.34821 10.0709 7.00893 11.8845C5.66964 13.6981 5 15.6764 5 17.8192C5 19.8951 5.63337 21.8176 6.90011 23.5866C8.16685 25.3555 9.87723 26.7757 12.0312 27.8472C11.0826 31.0391 10.5748 32.8528 10.5078 33.288V33.355C10.5078 33.3996 10.519 33.4499 10.5413 33.5057C10.5636 33.5615 10.5971 33.6061 10.6417 33.6396C10.7533 33.6954 10.8705 33.701 10.9933 33.6563C11.25 33.6229 13.365 32.2278 17.3382 29.4711C18.2533 29.5938 19.1406 29.6552 20 29.6552C22.7232 29.6552 25.2344 29.1279 27.5335 28.0732C29.8326 27.0185 31.6518 25.5815 32.9911 23.7623C34.3304 21.9431 35 19.9621 35 17.8192C35 15.6764 34.3304 13.6981 32.9911 11.8845C31.6518 10.0709 29.8298 8.63673 27.5251 7.58204ZM30.8513 21.6753C30.8207 21.7136 30.7862 21.7507 30.7478 21.7869C30.6826 21.8349 30.6177 21.8727 30.553 21.9001C30.6551 21.8263 30.7546 21.7514 30.8513 21.6753Z",
    fill: "#53E3AC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 17.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 17.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 17.5,
    r: 1.5,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifyTalk);
export default __webpack_public_path__ + "static/media/icon_notify_talk.ac10af4a.svg";
export { ForwardRef as ReactComponent };